import router from "./router/index"
router.beforeEach((to, from, next) => {
    document.title = to.meta?.title ? to.meta?.title : "39游戏盒子";
    next()
})